export default __webpack_public_path__ + "static/media/Two.8efe9e05.png";